module.exports = __webpack_public_path__ + "img/intLogo.6ee56320.png";